import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { login_action, forgetCheckedEmail_action, forgetGetOtp_action, forgetUpdatePassword_action, get_login_pass_action, forgetChecked_action } from '../../actions/user_login_auth_actions/user_login_auth_action';
import { insertUserRegistration_action, getExhibitionSSRCountryMappingData_action } from '../../actions/user_registration_action';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError, countryActionId, countryIWithCodeActionId, exhCompanyProfileActionID } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator, loginPasswordValidator, otpValidator, confirmPasswordValidator } from '../../utils/Validator'
import Modal from "react-modal";
import Footerlogin from '../../common_components/Footerlogin';
import AdminHeader from '../../common_components/admin_module_header';
import { fill_action } from '../../actions/fillCombo_action'
import ConfirmationModal from "../../common_components/confirmationa_modal";

/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/


// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }


class UserRegistration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            exhCode: '',
            countryList: [],
            ExhibitionID: '',

            companyName: '',
            companyNameErr: '',
            firstName: '',
            firstNameErr: '',
            lastName: '',
            lastNameErr: '',
            designation: '',
            designationErr: '',
            email: '',
            emailErr: '',
            mobNo: '',
            mobNoErr: '',
            countryId: '',
            countryList: '',
            countryErr: '',
            countryNamePreRegisterMobileNo: '',
            isOpen: false,
            isOpen2: false,
            // isOpen: false,
            otp: '',
            isOTPmatched: false,
            SSRLink: '',
            SSRCountryList: [],
            // companyProfileList: [],
            // selectedCompanyProfiles: [],
        }
        this.onFormSubmit = this.onFormSubmit.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.verifyOTP = this.verifyOTP.bind(this)
        this.getExhibitionSSRCountryMappingData = this.getExhibitionSSRCountryMappingData.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onFormSubmit()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        console.log('this.props.location.state', this.props.location.state)
        if (this.props.location.state != null && this.props.location.state != '' && this.props.location.state != undefined) {
            if (this.props.location.state.exhCode != null && this.props.location.state.exhCode != '' && this.props.location.state.exhCode != undefined) {
                this.setState({
                    exhCode: this.props.location.state.exhCode,
                })
                this.getFillList(countryIWithCodeActionId, '', '', '', this.props.location.state.exhCode, '')
                this.getExhibitionSSRCountryMappingData(this.props.location.state.exhCode)
                // this.getFillList(exhCompanyProfileActionID, '', '', '', '', '')
            }
        }
    }

    getExhibitionSSRCountryMappingData(exhCode) {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            this.props
                .getExhibitionSSRCountryMappingData_action(exhCode)
                .then((data) => {
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        // console.log(data.data, 'agent')
                        // var chapterIDArr = data.data[0]["ChapterID"] != '' && data.data[0]["ChapterID"] != null ? data.data[0]["ChapterID"].split(',') : []
                        // console.log(chapterIDArr, 'chapterIDArr')
                        // for (var i = 0; i < chapterIDArr.length; i++) {
                        //     chapterIDArr[i] = chapterIDArr[i].trim()
                        //     chapterIDArr[i] = parseInt(chapterIDArr[i])
                        // }
                        this.setState({ SSRCountryList: data.data });
                        // resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)

                        this.setState({
                            countryList: data.data, isLoading: false,
                        })
                    }
                    // Company Profile list
                    // if (actionID === exhCompanyProfileActionID) {
                    //     this.setState({ companyProfileList: data.data ?? [], isLoading: false })
                    // }
                    // ExhibitionID
                    if (actionID === countryIWithCodeActionId) {
                        if (data.data.length > 0) {
                            console.log("country data", data.data[0])
                            // console.log(data.data[0])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []

                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])
                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                            sessionStorage.setItem("SSRLink", data.data[0]['SSRLink'])

                            this.setState({
                                // isDataLoad: true,
                                // bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner'],
                                // website: data.data[0]['ExhMailWebsite'],
                                // isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                // isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                                ExhibitionID: data.data[0]['ExhibitionID']
                            })
                            this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')

                        } else {
                            this.setState({
                                isLoading: false,
                                // invalidLink: true 
                            })
                        }

                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    onFormSubmit() {
        const { userEmail, otp, password, isLoading, verifyEmail, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword, companyName, companyNameErr, firstName, firstNameErr, designation, designationErr, lastName, lastNameErr, email, emailErr, mobNo, mobNoErr, countryId, countryList, countryErr, isOpen, countryNamePreRegisterMobileNo } = this.state
        var Err = false
        var errMsg = ''
        if (companyName == '' || companyName == null) {
            this.setState({ companyNameErr: 'Please enter Company name' })
            Err = true
        }
        if (firstName == '' || firstName == null) {
            this.setState({ firstNameErr: 'Please enter First name' })
            Err = true
        }
        if (lastName == '' || lastName == null) {
            this.setState({ lastNameErr: 'Please enter Last name' })
            Err = true
        }
        if (designation == '' || designation == null) {
            this.setState({ designationErr: 'Please enter Designation' })
            Err = true
        }
        if (email == '' || email == null) {
            this.setState({ emailErr: 'Please enter Email' })
            Err = true
        } else {
            errMsg = emailValidator(email.trim())
        }
        if (mobNo == '' || mobNo == null) {
            this.setState({ mobNoErr: 'Please enter Mobile' })
            Err = true
        }
        if (countryId == '' || countryId == null || countryId == 0) {
            this.setState({ countryErr: 'Please select Country' })
            Err = true
        }
        if (Err) {
            toastError("Please Enter Mandatory Fields")
            return
        }
        if (errMsg != '') {
            toastError(errMsg)
            return
        }
        this.setState({ isLoading: true })
        this.props
            .insertUserRegistration_action(companyName, firstName, designation, lastName, email.trim(), countryNamePreRegisterMobileNo != null && countryNamePreRegisterMobileNo != '' ? `+${countryNamePreRegisterMobileNo}-${mobNo}` : mobNo, countryId, 1)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toast.success("OTP Sent to your Email", {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                    this.setState({
                        isOpen: true
                    })
                } else {
                    this.setState({ isLoading: false })
                    toast.error("Email ID already Registererd.\n Please Login", {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
            }).catch((e) => {
                console.log(e);
            });
    }

    verifyOTP() {
        const { userEmail, otp, password, isLoading, verifyEmail, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword, companyName, companyNameErr, firstName, designation, firstNameErr, lastName, lastNameErr, email, emailErr, mobNo, mobNoErr, countryId, countryList, countryErr, isOpen, isOTPmatched, exhCode } = this.state
        this.setState({ isLoading: true })
        this.props
            .forgetChecked_action(email, otp.trim(), 1, exhCode)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, isOTPmatched: true })
                    toast.success("OTP Verified", {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toast.error(data.msg, {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onChangePrimaryEmail(value) {
        var primaryAtcount = 0
        for (var i = 0; i < value.length; i++) {
            if (value[i] == '@') {
                primaryAtcount = primaryAtcount + 1
            }
        }
        if (primaryAtcount > 1) {
            this.setState({
                email: value,
                emailErr: "Multiple email id not allowed inside primary email"
            })

        } else {
            this.setState({
                email: value,
                emailErr: ''
            })
        }
    }

    render() {
        const { userEmail, isOpen2, otp, password, isLoading, isOpenConfirmationModal, SSRCountryList, verifyEmail, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword, countryNamePreRegisterMobileNo, companyName, companyNameErr, designation, designationErr, firstName, firstNameErr, lastName, lastNameErr, email, emailErr, mobNo, mobNoErr, countryId, SSRLink, countryList, countryErr, isOpen, companyProfileList, selectedCompanyProfiles } = this.state
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {/* PAGE */}
                    <div className="page">
                        <div className="page-main">
                            <AdminHeader isSteper={false} />
                            {/*app-content open*/}
                            {/* <div className="main-content app-content mt-0"> */}
                            <div className="side-app">
                                {/* <div className="main-container form-start container-fluid p-0">
                                        {is_update && <>
                                            <div className="row ">
                                                <div className="tab-scroll-fixed">
                                                    <p>Exhibitor Registration</p>
                                                </div>
                                            </div>
                                            <StepHeader />
                                        </>}
                                    </div> */}
                                {/* <StepHeader /> */}
                                <div className="page-height" style={{ marginTop: '7.3em' }}>
                                    <div className="main-container container-fluid"
                                    //  style={{ paddingLeft: '5em', paddingRight: '5em' }}
                                    >
                                        <div className="user-regist-tit">
                                            <h3 className="text-center user-reg-name text-primary py-2 mb-0">
                                                New Registration
                                            </h3>
                                            <div className="user-regist">
                                                <div className="form-row mb-1">
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            First Name<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={firstName}
                                                            maxLength={500}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    firstName: e.target.value,
                                                                    firstNameErr: "",
                                                                })
                                                            }
                                                        />
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {firstNameErr}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Last Name<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={lastName}
                                                            maxLength={500}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    lastName: e.target.value,
                                                                    lastNameErr: "",
                                                                })
                                                            }
                                                        />
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {lastNameErr}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="form-row mb-1">
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Designation<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={designation}
                                                            maxLength={500}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    designation: e.target.value,
                                                                    designationErr: "",
                                                                })
                                                            }
                                                        />
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {designationErr}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Company Name<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={companyName}
                                                            maxLength={500}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    companyName: e.target.value,
                                                                    companyNameErr: "",
                                                                })
                                                            }
                                                        />
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {companyNameErr}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Country<span className="text-red">*</span>
                                                        </label>
                                                        <select className="form-control select2 select-hidden-accessible pl-0"
                                                            style={{ width: "100%", fontSize: '15px' }}
                                                            value={countryId}
                                                            onChange={e => this.setState({ countryId: e.target.value, }, () => {

                                                                countryList.length > 0 && countryList.map((item) => {
                                                                    SSRCountryList.length > 0 ?
                                                                        SSRCountryList.map(item2 => {
                                                                            if (item2.CountryID == e.target.value) {
                                                                                this.setState({
                                                                                    isOpen2: true
                                                                                })
                                                                                return
                                                                            } else {
                                                                                item.Code == e.target.value && this.setState({
                                                                                    countryNamePreRegisterMobileNo: item.CountryCode, countryErr: ''
                                                                                })
                                                                            }
                                                                        }) :
                                                                        item.Code == e.target.value && this.setState({
                                                                            countryNamePreRegisterMobileNo: item.CountryCode, countryErr: ''
                                                                        })
                                                                })
                                                            })}>
                                                            <option value={0}>Select Your Country</option>
                                                            {
                                                                countryList.length > 0 && countryList.map((item) => (
                                                                    <option key={item.Code} value={item.Code}>{item.Description}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {countryErr}
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Email<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={email}
                                                            maxLength={500}
                                                            onChange={(e) => this.onChangePrimaryEmail(e.target.value)}

                                                        />
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {emailErr}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="form-row mb-1">
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Mobile No<span className="text-red">*</span>
                                                        </label>
                                                        <div className="phone-input-group">
                                                            <input
                                                                type="text"
                                                                placeholder="ISD"
                                                                className="form-control phone-code" autoComplete="off" readOnly
                                                                value={countryNamePreRegisterMobileNo}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control phone-no"
                                                                id="validationCustom03"
                                                                required=""
                                                                value={mobNo}
                                                                maxLength={500}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        mobNo: e.target.value,
                                                                        mobNoErr: "",
                                                                    })
                                                                }
    
                                                            />
                                                        </div>
                                                        {
                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                {mobNoErr}
                                                            </span>
                                                        }
                                                    </div>

                                                </div>
                                                {/* {companyProfileList != null && companyProfileList.length > 0 && (
                                                    <div className="form-row mb-1">
                                                        <div className="col-xl-12 mb-1">
                                                            <label>Company Profile</label>
                                                            <div className="d-flex flex-wrap" style={{ gap: '10px 30px' }}>
                                                                {companyProfileList.map((item) => (
                                                                    <div key={item.ExhCompanyProfileID} className="form-check" style={{ minWidth: '200px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            id={`profile_${item.ExhCompanyProfileID}`}
                                                                            value={item.ExhCompanyProfileID}
                                                                            checked={selectedCompanyProfiles.includes(item.ExhCompanyProfileID)}
                                                                            style={{ marginTop: '0', flexShrink: 0 }}
                                                                            onChange={(e) => {
                                                                                const val = item.ExhCompanyProfileID
                                                                                this.setState((prev) => ({
                                                                                    selectedCompanyProfiles: e.target.checked
                                                                                        ? [...prev.selectedCompanyProfiles, val]
                                                                                        : prev.selectedCompanyProfiles.filter((v) => v !== val)
                                                                                }))
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`profile_${item.ExhCompanyProfileID}`}>
                                                                            {item.Name}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}
                                                <button
                                                    className="btn btn-aqua d-block mx-auto mt-4 px-4 py-1"
                                                    type="submit"
                                                    // onClick={() => this.onFormSubmit()}
                                                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                                >

                                                    Submit
                                                </button>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </>
                <Modal isOpen={isOpen} onRequestClose={(e) => this.setState({ isOpen: false })}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail"
                    // tabIndex={-1}
                    // aria-labelledby="detailLabel"
                    // aria-hidden="true"
                    >
                        {this.state.isOTPmatched ?
                            // <div className="modal-dialog modal-md">
                            //     <div className="modal-content estimate-details">
                            //         <div className="modal-header pb-1">
                            //             <h5 className="modal-title" id="detailLabel">
                            //                 <strong>OTP Verified Successfully</strong>
                            //             </h5>
                            //             <button
                            //                 type="button"
                            //                 className="btn-close pt-6"
                            //                 data-bs-dismiss="modal"
                            //                 style={{ fontSize: 12 }}
                            //                 aria-label="Close"
                            //                 onClick={(e) => this.setState({ isOpen: false })}
                            //             />
                            //         </div>

                            //         <div className="modal-body p-2">
                            //             <button
                            //                 className="btn mt-4 mb-1 text-white"
                            //                 type="submit"
                            //                 style={{
                            //                     width: "20%",
                            //                     background: "#007bff",
                            //                     padding: 4
                            //                 }}
                            //                 onClick={() => this.props.navigate(`/login/${this.state.exhCode}`, { state: { ExhibitionId: this.state.ExhibitionID } })}
                            //             >
                            //                 {" "}

                            //                 Back to Login
                            //             </button>
                            //         </div>
                            //     </div>
                            // </div>

                            <div className="modal-dialog modal-md">
                                <div className="modal-content text-center p-4 w-auto" style={{ borderRadius: '20px', }}>
                                    <div className="d-flex justify-content-center mb-3">
                                        <div className='icon-bg'>
                                            <i className="bi bi-check-lg text-white" style={{ fontSize: '30px' }}></i>
                                            {/* Use Bootstrap Icons or replace with an inline SVG */}
                                        </div>
                                    </div>
                                    <link
                                        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
                                        rel="stylesheet"
                                    />
                                    <h5 className="fw-bold mb-2">Verified</h5>
                                    <p style={{ textAlign: 'center' }} className="text-muted mb-2">Your OTP has been verified successfully</p>
                                    <p className="text-muted mb-4">The login credentials sent to your email ID for further process</p>

                                    <button
                                        className="btn text-white"
                                        style={{
                                            backgroundColor: '#214291',
                                            borderRadius: '30px',
                                            padding: '7px 24px',
                                            fontWeight: '600'
                                        }}
                                        onClick={() =>
                                            this.props.navigate(`/login/${this.state.exhCode}`, {
                                                state: { ExhibitionId: this.state.ExhibitionID }
                                            })
                                        }
                                    >
                                        Back to Login
                                    </button>
                                </div>
                            </div>

                            :
                            <div className="modal-dialog modal-md">
                                <div className="modal-content estimate-details">
                                    <div className="modal-header pb-1">
                                        <h5 className="modal-title" id="detailLabel">
                                            <strong>OTP sent to your Email</strong>
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close pt-6"
                                            data-bs-dismiss="modal"
                                            style={{ fontSize: 12 }}
                                            aria-label="Close"
                                            onClick={(e) => this.setState({ isOpen: false })}
                                        />
                                    </div>
                                    <div className="modal-body p-2">
                                        <label htmlFor="validationCustom03">
                                            Enter OTP<span className="text-red">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="validationCustom03"
                                            required=""
                                            value={otp}
                                            maxLength={500}
                                            onChange={(e) =>
                                                this.setState({
                                                    otp: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="modal-footer pb-1">
                                        <button
                                            className="btn mt-4 btn-aqua mb-1"
                                            type="submit" onClick={() => this.verifyOTP()}
                                        >
                                            {" "}
                                            <a
                                                className="text-center text-white"
                                                style={{ color: 'white' }}
                                            >
                                                Submit
                                            </a>{" "}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal >
                <Modal isOpen={isOpen2} onRequestClose={(e) => this.setState({ isOpen2: false })}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail"
                    // tabIndex={-1}
                    // aria-labelledby="detailLabel"
                    // aria-hidden="true"
                    >
                        <div className="modal-dialog modal-md" style={{ maxWidth: '660px', marginTop: '1rem', marginLeft: '-9.5rem' }}>
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                        Kindly contact your country’s space selling representative to process space booking application.
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        <strong>
                                            <a className='text-primary' href={sessionStorage.getItem('SSRLink')} >Click here to view Space Selling Representative</a>
                                        </strong>
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 btn-aqua text-center"
                                        type="submit" onClick={() => this.props.navigate(`/login/${this.state.exhCode}`)}
                                    >
                                        {" "}
                                        <a
                                            className="text-center text-white"
                                            style={{ color: 'white' }}
                                        >
                                            OK
                                        </a>{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >

            </>


        )
    }
}

export default withRouter(connect(null, { fill_action, insertUserRegistration_action, forgetChecked_action, getExhibitionSSRCountryMappingData_action })(UserRegistration));